import DescriptionSection from './DescriptionSection';

export default DescriptionSection;
